import { showSnackbar, type SnackbarSeverity } from '@/shared/hooks/useSnackbar';

type ToastMessage = string;

function toMessage(message: ToastMessage): string {
  return typeof message === 'string' ? message : String(message);
}

function notify(message: ToastMessage, severity: SnackbarSeverity): void {
  showSnackbar(toMessage(message), severity);
}

/**
 * Drop-in replacement for react-toastify's `toast` API, backed by AppSnackbar.
 * Prefer `useSnackbar()` / `showSnackbar` in new code.
 */
export const toast = {
  success: (message: ToastMessage) => notify(message, 'success'),
  error: (message: ToastMessage) => notify(message, 'error'),
  info: (message: ToastMessage) => notify(message, 'info'),
  warning: (message: ToastMessage) => notify(message, 'warning'),
  warn: (message: ToastMessage) => notify(message, 'warning'),
};

export default toast;
